<div *ngIf="!hideFilter" class="row mb-2">
  <div class="col">
    <div class="d-block d-md-flex">
      <select class="form-control mr-2 mb-1" [(ngModel)]="searchParams.tag" (change)="search(true)">
        <option [ngValue]="null">Filter: All Tags</option>
        <option *ngFor="let tag of tags" value="{{ tag.name }}">Tag: {{ tag.name }}</option>
      </select>

      <select class="form-control mr-2 mb-1" [(ngModel)]="searchParams.orderBy" (change)="search(true)">
        <option *ngFor="let item of OrderByEnum | keyvalue" value="{{ item.key }}">Order By: {{ item.value }}</option>
      </select>

      <select class="form-control mr-2 mb-1" [(ngModel)]="searchParams.selectedDay" (change)="search(true)">
        <option [ngValue]="null">Date: Any</option>
        <option *ngFor="let item of conference?.dayLabels" [ngValue]="item">{{ item }}</option>
      </select>

      <select class="form-control mb-1" [(ngModel)]="searchParams.roomId" (change)="search(true)">
        <option [ngValue]="null">Any Room</option>
        <option *ngFor="let item of rooms" [ngValue]="item.id">{{ item.roomName }}</option>
      </select>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="input-group mb-3">
      <input type="text" class="form-control" placeholder="Search by title, presenter, CEU type or ID..." (keyup.enter)="search(true)" [(ngModel)]="searchParams.searchText" />
      <div class="input-group-append">
        <button class="btn btn-outline-danger" type="button" (click)="searchParams.searchText = ''; search(true)">Clear</button>
        <button class="btn btn-outline-secondary" type="button" (click)="search(true)">Search</button>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="searching">
  <div *ngFor="let item of [].constructor(20)" class="mb-2">
    <p-skeleton width="100%" height="300px"></p-skeleton>
  </div>
</ng-container>

<ng-container *ngFor="let event of events">
  <div class="border-bottom mb-5">
    <bxl-event-item [rootRoute]="'/conferences/' + conference.slug" [event]="$any(event)"></bxl-event-item>
  </div>
</ng-container>

<div class="row no-gutters no-candidates" style="height: 300px" *ngIf="!searching && events && events.length == 0">
  <div class="col-sm-12 my-auto">
    <h1><i class="fas fa-empty-set"></i></h1>
    <h4>No Results</h4>
    <p>Please modify your search and try again.</p>
  </div>
</div>
<p-paginator *ngIf="events && events.length > 0" [rows]="pageSize" [first]="currentPage * pageSize" [totalRecords]="resultCount" (onPageChange)="paginate($event)" [rowsPerPageOptions]="[10, 15, 20, 30, 50]"></p-paginator>
